import { Button, Text } from '@morressier/ts';
import { IButtonProps } from '@morressier/ts/_dist/cjs/forms/Button';
import React, { useState, useEffect } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import * as Styles from './styles';

type IDropDownButton = {
  dropdownOptions?: { label: string; value: string }[];
  onDropdownChange?: ({ value, label }: { value: string; label: string }) => void;
  useDefaultName?: boolean;
  useButton?: boolean;
  style?: React.CSSProperties;
  otherProps?: { [prop: string]: string };
  buttonProps?: IButtonProps;
  dropdownContainerStyle?: React.CSSProperties;
};

// Just a simple dropdown use case. Probably no need for portal or Custom flyout yet
export const SimpleDropdown: React.FC<IDropDownButton> = props => {
  const {
    dropdownOptions = [],
    onDropdownChange,
    children,
    useDefaultName = true,
    style,
    buttonProps,
    useButton,
    otherProps,
    dropdownContainerStyle,
  } = props;
  const [name, setName] = useState(dropdownOptions ? dropdownOptions[0]?.label : '');
  const [showDropDown, setshowDropDown] = useState(false);

  const toggleDropDown = () => {
    setshowDropDown(!showDropDown);
  };

  useEffect(() => {
    const closeDropDown = () => {
      if (showDropDown) {
        setshowDropDown(false);
      }
    };

    window.addEventListener('click', closeDropDown);

    return () => window.removeEventListener('click', closeDropDown);
  }, [showDropDown]);

  const handleDropdownClick = (value: string, label = '') => {
    setName(label || value);

    if (onDropdownChange) {
      onDropdownChange({ value, label });
    }
  };

  return (
    <Styles.DropDownStack>
      {useButton ? (
        <Button
          onClick={() => toggleDropDown()}
          loading={buttonProps?.loading}
          style={{
            ...style,
          }}
          {...buttonProps}
        >
          {useDefaultName ? name : children} <FaChevronDown color="grey" className="ml1" />
        </Button>
      ) : (
        <Text
          onClick={() => toggleDropDown()}
          style={{
            ...style,
          }}
          {...otherProps}
        >
          {useDefaultName ? name : children}{' '}
          <FaChevronDown size="0.75rem" color="grey" className="ml2 mr1" />
        </Text>
      )}
      {showDropDown && (
        <Styles.DropDownContainer style={{ ...dropdownContainerStyle }}>
          {dropdownOptions?.map(({ label, value }) => (
            <Styles.DropDownItem
              key={`${value}-${label}`}
              onClick={() => handleDropdownClick(value, label)}
              onKeyPress={() => handleDropdownClick(value, label)}
              role="presentation"
            >
              <Text>{label || value}</Text>
            </Styles.DropDownItem>
          ))}
        </Styles.DropDownContainer>
      )}
    </Styles.DropDownStack>
  );
};

SimpleDropdown.defaultProps = {
  onDropdownChange: () => null,
};
